document.addEventListener('DOMContentLoaded', () => {
  const collectionPage = document.querySelector('.shop-all-page');
  if (!collectionPage) return;

  const sortSelect = document.getElementById('sort-by');

  if (sortSelect) {
    const urlParams = new URLSearchParams(window.location.search);
    const currentSort = urlParams.get('sort_by');

    if (currentSort) {
      sortSelect.value = currentSort;
    }

    sortSelect.addEventListener('change', function () {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', this.value);
      window.location.href = url.toString();
    });
  }

  const quickAddForms = document.querySelectorAll('.quick-add-form');

  const updateCartCount = (cart) => {
    const cartCount = document.querySelector('.cart-count');
    if (cartCount) {
      cartCount.textContent = cart.item_count;
      cartCount.style.display = cart.item_count > 0 ? 'flex' : 'none';
      return;
    }

    if (cart.item_count > 0) {
      const cartLink = document.querySelector('.cart-link');
      if (cartLink) {
        const newCount = document.createElement('span');
        newCount.className = 'cart-count';
        newCount.textContent = cart.item_count;
        cartLink.appendChild(newCount);
      }
    }
  };

  const addItem = (formData) => {
    if (window.TGLCartDrawer && typeof window.TGLCartDrawer.addItem === 'function') {
      return window.TGLCartDrawer.addItem(formData);
    }

    return fetch('/cart/add.js', {
      method: 'POST',
      body: formData
    })
      .then((response) => response.json())
      .then(() =>
        fetch('/cart.js')
          .then((response) => response.json())
          .then(updateCartCount)
      );
  };

  quickAddForms.forEach((form) => {
    form.addEventListener('submit', (event) => {
      event.preventDefault();

      const formData = new FormData(form);
      const button = form.querySelector('.quick-add-btn');

      button.textContent = 'Adding...';
      button.disabled = true;

      addItem(formData)
        .then(() => {
          button.textContent = 'Added!';
        })
        .catch((error) => {
          console.error('Error adding to cart:', error);
          button.textContent = 'Error';
        })
        .finally(() => {
          setTimeout(() => {
            button.textContent = 'Add to Cart';
            button.disabled = false;
          }, 2000);
        });
    });
  });
});
